











import Vue from 'vue'
import CommonArrow from '@/components/shared/atoms/Icon/CommonArrow'
import IFAQContentProps from '@/entities/FAQContent'

export default Vue.extend({
  components: {
    CommonArrow
  },
  props: {
    faqData: {
      // 前提として検索してfilterで抽出した配列をpropsで受けます
      type: Array as () => IFAQContentProps[],
      default: () => []
    },
    isAnimation: {
      type: Boolean,
      default: false
    }
  }
})
